import React from 'react';
import ajax from '../../ajax';
import functions from '../../functions';
import ActivityLoader from '../Common/ActivityLoader';
import PopFloatApproval from './PopFloatApproval';

class OngoingFloatRequests extends React.Component {

    state={
        userId:functions.sessionGuard(),
        accessInfo:false,
        transactionList:false,
        popApproval:false
       
    }

  async componentDidMount()
  {
    await this.requestRecord();
    this.timer = setTimeout(this.func=async()=> {
      await this.requestRecord();
      this.timer = setTimeout(this.func, 2000); // (*)
    }, 10000);
  }

  componentWillUnmount()
  {
    clearTimeout(this.timer)
  }


   

    readUser=async()=>
    {
        const server_reponse=await ajax.getUserAccess(this.state.userId);
        if(server_reponse.status==="OK")
        {
            this.setState({
               accessInfo:server_reponse.details.list,
            })
        }
    }


  requestRecord=async()=>{
    const server_response=await ajax.listOngoingFloatRequests(1);
    if(server_response.status==="OK")
    {
      this.setState({
        transactionList:server_response.details.list
      })
    }else{
        this.setState({
            transactionList:'404'
          })
    }
  }


  onClickRecord=(record)=>
  {
        this.setState({
            popApproval:false
        }, ()=>{
            this.setState({
                popApproval:<PopFloatApproval record={record}/>
            }, ()=>{
                functions.openPopup('mdl-security-approval')
            })
        })
  }
   
  render(){

    const list=this.state.transactionList;
    
      return (
        <>
        {this.state.popApproval}
        <div className="card custom-card">
            <div className="card-body">
                <div>
                    <h6 className="card-title mb-1">Float Requests</h6>
                    <p className="text-muted mb-0 card-sub-title">Ongoing Capital Float Requests</p>
                </div>
            </div>
            <div className="user-manager scroll-widget border-top">
                <div className="table-responsive">
                    <table className="table mg-b-0">
                        <tbody>
                           {list && list!=="404" && list.map((item, key)=>
                            <tr key={key} 
                                className="hot-tr"
                                onClick={()=>this.onClickRecord(item)}>
                                <td className="bd-t-0">
                                <div className="main-img-user">
                                        <img alt="avatar" src={item.user.photo}/>
                                    </div>
                                </td>
                                <td className="bd-t-0">
                                    <h6 className="mg-b-0">{item.user.first_name + ' ' + item.user.last_name}</h6>
                                    <small className="tx-11 tx-gray-500">{item.user.phone}</small>
                                </td>
                                <td className="bd-t-0">
                                    <h6 className="mg-b-0 font-weight-bold">{item.amount.amount_c}</h6>
                                    <small className="tx-11 tx-gray-500">
                                        {item.status.status_name}
                                    </small>
                                </td>
                            </tr>)}
                           
                        </tbody>
                    </table>
                
                
                {!this.state.transactionList && <ActivityLoader/>}
                
                </div>
            </div>
        </div>
        </>
      )
    
 
  }
}

export default OngoingFloatRequests;